import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { Button, Result, Select } from "antd";
import moment from "moment";
import Axios from "../../Axios";

import { CategoryFilter } from "./CategoryFilter";
import Visualizer from "./Visualizer";

const { Option } = Select;

export const HeatMap = ({ payload }) => {
  const [categories, setCategories] = useState([]);
  const [filter, setFilter] = useState({
    category: null,
    dateRange: [
      moment().startOf("month").format("YYYY-MM-DD"),
      moment().endOf("month").format("YYYY-MM-DD"),
    ],
  });

  // Carga categorías
  useEffect(() => {
    (async () => {
      const { data } = await Axios.get("/utils/enabled-categories/children");
      setCategories(data.data);
    })();
  }, []);

  const filterByCategory = (id) => {
    setFilter((prev) => ({ ...prev, category: id }));
  };

  // Pre-calc rango de fechas
  const ranges = {
    lastWeek: [
      moment().subtract(1, "week").startOf("isoWeek").format("YYYY-MM-DD"),
      moment().subtract(1, "week").endOf("isoWeek").format("YYYY-MM-DD"),
    ],
    thisWeek: [
      moment().startOf("isoWeek").format("YYYY-MM-DD"),
      moment().endOf("isoWeek").format("YYYY-MM-DD"),
    ],
    thisMonth: [
      moment().startOf("month").format("YYYY-MM-DD"),
      moment().endOf("month").format("YYYY-MM-DD"),
    ],
    lastMonth: [
      moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD"),
      moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD"),
    ],
  };

  const handleDateSelect = (value) => {
    if (!value) {
      // limpiar filtro de fecha
      setFilter((prev) => ({ ...prev, dateRange: [null, null] }));
    } else {
      setFilter((prev) => ({ ...prev, dateRange: ranges[value] }));
    }
  };

  if ( !['admin','auditor'].includes(payload.role)) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="Sorry, you are not authorized to access this page."
        extra={<Button type="primary">Back Home</Button>}
      />
    );
  }

  return (
    <div style={{ position: "relative", width: "100%", height: "600px", padding: 16 }}>
      {/* Filtro de categoría */}
      <CategoryFilter categories={categories} onChange={filterByCategory} />

      {/* Filtro de rango de fecha */}
      <Select
        defaultValue={'thisMonth'}
        placeholder="Selecciona rango de fecha"
        style={{ width: 200, marginLeft: 16, marginBottom: 20 }}
        onChange={handleDateSelect}
        allowClear
      >
        <Option value="thisWeek">Esta semana</Option>
        <Option value="lastWeek">Semana pasada</Option>
        <Option value="thisMonth">Este mes</Option>
        <Option value="lastMonth">Mes pasado</Option>
      </Select>

      {/* Visualizador recibe category y dateRange */}
      <Visualizer filter={filter} />
    </div>
  );
};
